package com.eladfinish.bible.contest.data.common

import com.eladfinish.bible.contest.SharedRes
import dev.icerock.moko.resources.AssetResource
import dev.icerock.moko.resources.getAssetByFilePath

interface AssetReader {
    val fileSeparator: String
    fun readFile(assetResource: AssetResource): String
    fun readFile(fileName: String): String
    fun list(path: String): List<String>
    fun readBinaryFile(fileName: String): ByteArray

    fun readFileShared(fileName: String): String {
        val assetResource = SharedRes.assets.getAssetByFilePath(filePath = fileName)!!
        return readFile(assetResource)
    }

    /**
     * Warms any internal cache for [fileNames] concurrently before a caller runs many sequential
     * [readFile] calls. No-op by default (Android/iOS reads are cheap local disk reads); the web
     * target overrides this since its [readFile] is a blocking synchronous fetch per file and
     * would otherwise freeze the tab across dozens of sequential reads (e.g. root/number search
     * results spanning many chapters).
     */
    suspend fun prefetch(fileNames: List<String>) {}
}

expect class AssetReaderImpl : AssetReader {
    override val fileSeparator: String
    override fun readFile(assetResource: AssetResource): String
    override fun readFile(fileName: String): String
    override fun list(path: String): List<String>
    override fun readBinaryFile(fileName: String): ByteArray
}
